// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"3390d576","585":"0e0e27d5","600":"9bbdd5ba","787":"7e843ae8","932":"d15154c3"}[chunkId] + ".chunk.js";
};